import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192.57 291.24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m189.42 261.6-26 26.35c-4.2 4.58-9.55 4.2-13.75 0l-93.15-93.19v86.69c0 6.11-3.44 9.55-9.55 9.55H9.55C3.44 291 0 287.56 0 281.45V9.55C0 3.44 3.44 0 9.55 0H47c6.11 0 9.55 3.44 9.55 9.55v89h126.38c6.11 0 9.54 3.44 9.54 9.55v37.8c0 6.11-3.43 9.55-9.54 9.55H97l92.42 92.42c4.2 4.18 4.2 9.13 0 13.73" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }